<template>
    <ion-page >
        <ion-content style="height: 100%; overflow-y: auto; text-align:center; padding-top: 56px;">
            <!-- Adjust padding-top to ensure content is not blocked by the header -->
            <ion-item style="text-align:center" lines="none">
                <ion-label class="blue" style="font-size: xx-large;"><b>Careers</b></ion-label>
            </ion-item>
            <ion-item style="text-align:center" lines="none">
                <ion-label style="font-size: large;"><b>Electrician Requirements:</b>
                </ion-label>
            </ion-item>
            <ion-item lines="none" class="center-container">
                <ion-label class="inner-text blue">
                    - At least 3 years of experience on commercial jobs<br>
                    - Must have experience installing panels, running/bending pipe, pulling wire etc.<br>
                    - Must have all basic tools, including drills.<br>
                    - Must have own PPE and a reliable means of transportation.<br>

                </ion-label>
            </ion-item>
            <ion-item style="text-align:center" lines="none">
                <ion-label style="font-size: large;"><b>General Requirements:</b>
                </ion-label>
            </ion-item>
            <ion-item class="center-container">
                <ion-label class="inner-text blue">
                    - Able to work outdoors in all weather conditions.<br>
                    - Able to lift and carry up to 50 pounds without assistance.<br>
                    - Must be able to pass a background check.<br>
                    - Able to perform work on uneven surfaces; frequently climb ladders, on/off equipment and work from
                    various heights.<br>
                    - Able and willing to walk, stand, bend, and sit for long periods of time.<br>
                    - Able to use your hands to perform activities involving holding, grasping, turning and pulling.<br>
                    - Follow safety policies and procedures and wear the required personal protective equipment required
                    for the job in a safe manner..<br>
                    - Must be able to pass a background check.<br>
                    <br>
                    JLA Badge is a plus but not required.<br>
                    <br>
                    Pay is based on experience.


                </ion-label>
            </ion-item>
            <ion-item lines="none">
        <div style="width:100%; display:flex; justify-content:center;">
          <ion-button style="width: 70vw;" class="estimate-cta" expand="block" shape="round" size="large"
            @click="$router.push('/career')">
            Apply Now!
          </ion-button>
        </div>
      </ion-item>

        </ion-content>


    </ion-page>
</template>
<script setup lang="ts">
import settings from "@/settings/email.json";

import { computed, ref, defineComponent } from "vue";
import {
    IonTextarea,
    IonCheckbox,
    IonPage,
    IonLabel,
    IonIcon,
    IonHeader,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonGrid,
    IonMenuButton,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio,
    toastController
} from "@ionic/vue";












interface WorkExperience {
    employerName: string;
    jobTitle: string;
    startDate: string;
    endDate: string;
    description: string;
    to: boolean;
}

let application = ref<{
    name: string;
    phone: string;
    email: string;
    contactMethod: string;
    position: string;
    workExperience: WorkExperience[];
}>({
    name: "",
    phone: "",
    email: "",
    contactMethod: "",
    position: "",
    workExperience: []
});


function addWorkExperience() {
    application.value.workExperience.push({ employerName: "", jobTitle: "", startDate: "", endDate: "", description: "", to: false });
}

function formatDateMMDDYYYY(dateStr: string): string {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${month}/${day}/${year}`;
}

function calculateDuration(startDate: string, endDate: string): string {
    if (!startDate) return '';
    const start = new Date(startDate);
    const end = endDate && endDate !== 'Present' ? new Date(endDate) : new Date();
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();
    if (days < 0) {
        months--;
        // Get days in previous month
        const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
    }
    if (months < 0) {
        years--;
        months += 12;
    }
    return `${years} Year${years > 1 ? "s" : ""} ${months} Month${months > 1 ? "s" : ""} ${days} day${days > 1 ? "s" : ""}`;
}

async function submitApplication() {
    let val = settings.applicationBody

    val = val.replace("%req.name%", application.value.name)
    val = val.replace("%req.email%", application.value.email)
    val = val.replace("%req.number%", application.value.phone)
    val = val.replace("%req.contact%", application.value.contactMethod)
    val = val.replace("%req.position%", application.value.position)

    /*
    
    <ul>
            <li><b>Employer Name:</b> $comp.name%</li>
            <li><b>Job Title:</b> %comp.number%</li>
            <li><b>Start-End Date:</b> %comp.address1%</li>
            <li><b>Description:</b> %comp.address2%</li>
        </ul>
        */
    let inst = ""
    for (let i = 0; i < application.value.workExperience.length; i++) {
        const exp = application.value.workExperience[i];
        const start = formatDateMMDDYYYY(exp.startDate);
        const end = exp.to ? "Present" : formatDateMMDDYYYY(exp.endDate);
        const calculated = calculateDuration(exp.startDate, exp.to ? '' : exp.endDate);
        inst += `<ul>
            <li><b>Employer Name:</b> ${exp.employerName}</li>
            <li><b>Job Title:</b> ${exp.jobTitle}</li>
            <li><b>Start-End Date:</b> ${start} - ${end} : ${calculated}</li>
            <li><b>Description:</b> ${exp.description}</li>
        </ul>`;
    }




    val = val.replace("<work-experience>", inst)
    val = val.replace("%def.datetime%", new Date().toLocaleString())




    let toastMessage = ""
    await sendEmail(settings.fromAddress, "jmeyer@aes-mlb.com", application.value.position + " Application for " + application.value.name, val).then((test) => {
        console.log("Email sent successfully");
        toastMessage = "Your application has been submitted successfully! We will get back to you as soon as possible.";

    }).catch((error) => {
        console.error("Error sending email:", error);
        toastMessage = "There was an error submitting your application. Please try again later.";
    });
    const toast = await toastController.create({
        message: toastMessage,
        duration: 1500,
        position: "bottom",

    });

    toast.present();


}











</script>

<style>
--blue {
    color: #1C8AF7 !important;
}

.blue {
    color: #1C8AF7 !important;
}

.grey {
    color: #99aab5 !important;
}

.center-container {
    display: flex;
    justify-content: center;
    /* Horizontally center */
}

.inner-text {
    text-align: left;
    /* Lines start at same point */
}
</style>

<script lang="ts">
import * as outlines from 'ionicons/icons';
import { sendEmail } from "@/EmailHelper";


</script>